<div class="topHead">
    <h2>Reset Requests</h2>
    <!-- <div class="logout">
        <b>Pratibha Sharma</b>
        <a href="javascript:void(0);" ><img src="assets/images/admin/power.png"/> </a>
    </div> -->
    <div class="logout">
        <app-log-out class="logout"></app-log-out>
    </div>
</div>
<div class="centerWrap">
    <div class="pageTitleBox">
        <h2>Reset Requests</h2> 
    </div>
<div class="adminTabWrap">
     <div class="filterWrap">
        <div class="searchWrap mr-5">
            <input type="text" placeholder="Search by User Name" (keyup)="search($event)"/>
        </div>
       <!-- <a href="javascript:void(0);" [routerLink]="['/authoring_create']" class="btn btn-primary btn-sm" >+ Create New Content Capsule</a>-->
    </div> 
    <mat-tab-group animationDuration="0ms" (selectedTabChange)="onSelectChange($event)">
        <mat-tab label="Pending" >
            <div class="tableWrap">
                <table class="mat-elevation-z8 w-100" matSort (matSortChange)="sortData($event)">
                    <thead>
                        <tr>
                            <th><div mat-sort-header="first_name"><b></b> Users</div></th>
                            <th><div mat-sort-header="course_name"><b></b> Courses Name</div></th>
                            <th><div mat-sort-header="percent_complete"><b></b>% Completed</div></th>
                            <th>Modules /<br/>
                                Submodule</th>
                            <th>Attempt Request<br/>
                                Count</th>
                                <th>
                                <div class="reset_requestTh">Assessment<br/> Reset Request <b><img src="assets/images/admin/frame_red.png" /></b></div></th>
                            <th>&nbsp;</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let values of userData; let i = index">
                            <td>
                                <div class="userTdWrap">
                                  <a class="btn-link">  <b [routerLink]="['/courses_details']">{{values.first_name}} {{values.last_name}}</b></a>
                                    <b class="d-block">Created on {{values.user_created_dttm | date:'d MMM, y'}}</b>
                                </div>
                            </td>
                            <td>
                                <div class="userTdWrap">
                                    <a href="javascript:void(0);" class="btn-link" [routerLink]="['/reset_request']" [queryParams]="{courseId:values.course_id,userId:values.user_id,type:'reset' }">{{values.course_name}} </a>
                                    <b class="d-block">Assigned on {{values.course_created_dttm | date:'d MMM, y'}}</b>
                                </div>
                            </td>
                            <td>
                                <b class="blue">{{values.percent_complete}}%</b>
                            </td>
                            <td>{{values.module_count}}/{{values.sub_module_count}}</td>
                            
                            <td><span>{{values.req_attempt}}</span></td>
                            <td><div class="moduleWrap">
                                <div class="moduleChoues">
                                    <a href="javascript:void(0);" class="moduleList mr-3"  (click)="openAccept(AcceptContent,values)">
                                    <i><img src="assets/images/admin/done.png" /></i>Accept
                                    </a>
                                    <a href="javascript:void(0);" class="moduleList" (click)="openReject(RejectContent,values)">
                                        <i><img src="assets/images/admin/close_big.png" /></i>Reject
                                    </a>
                                </div>
                              
                            </div></td>
                            <td class="pl-2 pr-2">
                                <ul class="userActionBtn">
                                    <li><a href="javascript:void(0);" class="btn-link" [routerLink]="['/reset_request']" [queryParams]="{courseId:values.course_id,userId:values.user_id,type:'reset' }">VIEW DETAILS</a></li>
                                </ul>
                            </td>
                        </tr>
                        <tr style="background-color: white;" class="selectTr" *ngIf="(userData && userData.length == 0)"><td [attr.colspan]="6">No Record found.</td></tr>
                    </tbody>
                </table>
            </div>
        </mat-tab>
        <mat-tab label="Accepted" >
            <div class="tableWrap">
                <table class="mat-elevation-z8 w-100" matSort (matSortChange)="sortData($event)">
                    <thead>
                        <tr>
                            <th><div mat-sort-header="first_name"><b></b> Users</div></th>
                            <th><div mat-sort-header="course_name"><b></b> Courses Name</div></th>
                            <th><div mat-sort-header="percent_complete"><b></b>% Completed</div></th>
                            <th>Modules /<br/>
                                Submodule</th>
                            <th>Attempt Request<br/>
                                Count</th>
                                <!-- <th>
                                <div class="reset_requestTh">Assessment<br/> Reset Request <b><img src="assets/images/admin/frame_red.png" /></b></div></th>
                            <th>&nbsp;</th> -->
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let values of userData; let i = index">
                            <td>
                                <div class="userTdWrap">
                                    <a class="btn-link">  <b>{{values.first_name}} {{values.last_name}}</b></a>
                                    <b class="d-block">Created on {{values.user_created_dttm | date:'d MMM, y'}}</b>
                                </div>
                            </td>
                            <td>
                                <div class="userTdWrap">
                                    <b>{{values.course_name}} </b>
                                    <b class="d-block">Assigned on {{values.course_created_dttm | date:'d MMM, y'}}</b>
                                </div>
                            </td>
                            <td>
                                <b class="blue">{{values.percent_complete}}%</b>
                            </td>
                            <td>{{values.module_count}}/{{values.sub_module_count}}</td>
                            
                            <td><b>{{values.req_attempt}}</b></td>
                            <!-- <td><div class="moduleWrap">
                                <div class="moduleChoues">
                                    <a href="javascript:void(0);" class="moduleList mr-3"  (click)="openAccept(AcceptContent,values)">
                                    <i><img src="assets/images/admin/done.png" /></i>Accept
                                    </a>
                                    <a href="javascript:void(0);" class="moduleList" (click)="openReject(RejectContent,values)">
                                        <i><img src="assets/images/admin/close_big.png" /></i>Reject
                                    </a>
                                </div>
                              
                            </div></td> -->
                            <!-- <td class="pl-2 pr-2">
                                <ul class="userActionBtn">
                                    <li><a href="javascript:void(0);" class="btn-link" [routerLink]="['/reset_request']">VIEW DETAILS</a></li>
                                </ul>
                            </td> -->
                            <td class="pl-2 pr-2">
                                <ul class="userActionBtn">
                                    <li><a href="javascript:void(0);" class="btn-link" [routerLink]="['/reset_request']" [queryParams]="{courseId:values.course_id,userId:values.user_id,type:'reset' }">VIEW DETAILS</a></li>
                                </ul>
                            </td>
                        </tr>
                        <tr style="background-color: white;" class="selectTr" *ngIf="(userData && userData.length == 0)"><td [attr.colspan]="6">No Record found.</td></tr>
                    </tbody>
                </table>
            </div>

        </mat-tab>
        <mat-tab label="Rejected" >
            <div class="tableWrap">
                <table class="mat-elevation-z8 w-100" matSort (matSortChange)="sortData($event)">
                    <thead>
                        <tr>
                            <th><div mat-sort-header="first_name"><b></b> Users</div></th>
                            <th><div mat-sort-header="course_name"><b></b> Courses Name</div></th>
                            <th><div mat-sort-header="percent_complete"><b></b>% Completed</div></th>
                            <th>Modules /<br/>
                                Submodule</th>
                            <th>Attempt Request<br/>
                                Count</th>
                                <!-- <th>
                                <div class="reset_requestTh">Assessment<br/> Reset Request <b><img src="assets/images/admin/frame_red.png" /></b></div></th> -->
                            <th>&nbsp;</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let values of userData; let i = index">
                            <td>
                                <div class="userTdWrap">
                                    <b>{{values.first_name}} {{values.last_name}}</b>
                                    <b class="d-block">Created on {{values.user_created_dttm | date:'d MMM, y'}}</b>
                                </div>
                            </td>
                            <td>
                                <div class="userTdWrap">
                                    <b >{{values.course_name}} </b>
                                    <b class="d-block">Assigned on {{values.course_created_dttm | date:'d MMM, y'}}</b>
                                </div>
                            </td>
                            <td>
                                <b class="blue">{{values.percent_complete}}%</b>
                            </td>
                            <td>{{values.module_count}}/{{values.sub_module_count}}</td>
                            
                            <td><b>{{values.req_attempt}}</b></td>
                            <!-- <td><div class="moduleWrap">
                                <div class="moduleChoues">
                                    <a href="javascript:void(0);" class="moduleList mr-3"  (click)="openAccept(AcceptContent,values)">
                                    <i><img src="assets/images/admin/done.png" /></i>Accept
                                    </a>
                                    <a href="javascript:void(0);" class="moduleList" (click)="openReject(RejectContent,values)">
                                        <i><img src="assets/images/admin/close_big.png" /></i>Reject
                                    </a>
                                </div>
                              
                            </div></td> -->
                            <!-- <td class="pl-2 pr-2">
                                <ul class="userActionBtn">
                                    <li><a href="javascript:void(0);" class="btn-link" [routerLink]="['/reset_request']">VIEW DETAILS</a></li>
                                </ul>
                            </td> -->
                            <td class="pl-2 pr-2">
                                <ul class="userActionBtn">
                                    <li><a href="javascript:void(0);" class="btn-link" [routerLink]="['/reset_request']" [queryParams]="{courseId:values.course_id,userId:values.user_id,type:'reset' }">VIEW DETAILS</a></li>
                                </ul>
                            </td>
                        </tr>
                        <tr style="background-color: white;" class="selectTr" *ngIf="(userData && userData.length == 0)"><td [attr.colspan]="6">No Record found.</td></tr>
                    </tbody>
                </table>
            </div>
        </mat-tab>
      </mat-tab-group>
</div>
</div>

<ngx-spinner><p style="color: white" > Loading... </p></ngx-spinner>

<ng-template #RejectContent let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click');getUserList(this.searchText, this.order_by, this.order, this.status);">
                <span aria-hidden="true">&times;</span>
            </button>
            <h6>Reject Reset Request</h6>

            <!-- <form [formGroup]="rejectForm">
                <div class="commanInput">
                    <mat-form-field class="example-full-width">
                        <mat-label>Remark</mat-label>
                        <input matInput formControlName="txtRemark" [ngClass]="{ 'is-invalid': submitted && f.txtRemark.errors }" autocomplete="off">
                    </mat-form-field> 
                    <div *ngIf="submitted && f.txtRemark.errors">
                        <span *ngIf="f.txtRemark.errors.required" class="text-mute text-danger errorText">This field is required</span>
                    </div>
                </div>
                <a href="javascript:void(0);" class="btn btn-primary btn-sm btn-border" (click)="modal.close('Close click')"> <span>Close</span>
                </a>
                <a href="javascript:void(0);" class="btn btn-primary btn-sm ml-2 mr-2" (click)="onSubmit(rejectForm.value)">Submit</a>
              </form> -->
            <p>You have rejected the reset request.</p>

            <a href="javascript:void(0);" class="backPage ml-2 mr-2" (click)="modal.close('Close click'); getUserList(this.searchText, this.order_by, this.order, this.status)">
                <span>Close</span>
            </a>

        </div>
    </div>
</ng-template>
  <ng-template #AcceptContent let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click');getUserList(this.searchText, this.order_by, this.order, this.status)">
                <span aria-hidden="true">&times;</span>
              </button>
            <h6>Accept Reset Request</h6>
            <p>You have approved the reset request.</p>
        
        <a href="javascript:void(0);" class="backPage ml-2 mr-2" (click)="modal.close('Close click');getUserList(this.searchText, this.order_by, this.order, this.status)">
            <span>Close</span>
        </a>
    </div>
    </div>
  </ng-template>

  
